import { Template } from "./templates/async-tab-template";
import { TemplateScrollWhenActivated } from "./templates/async-tab-scroll-when-activated";
import { TemplateFixToTop } from "./templates/async-tab-fix-to-top";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Async Tab",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-async-tab",
    args: {
        errorMessage:
            "The data can not be retrieved at the moment. Please try again later.",
        name: "",
        reloadOnActivation: false,
        tabId: "",
        url: "",
    },
    argTypes: {
        errorMessage: { control: "text" },
        name: { control: "text" },
        reloadOnActivation: { control: "boolean" },
        tabId: { control: "text" },
        url: { control: "text" },
    },
};

export const Default = Template.bind({});
Default.args = {
    reloadOnActivation: false,
};

export const ReloadOnActivation = Template.bind({});
Default.args = {
    reloadOnActivation: true,
};

export const ScrollWhenActivated = TemplateScrollWhenActivated.bind({});

export const FixToTop = TemplateFixToTop.bind({});
